import { render, staticRenderFns } from "./autoRouterparent.vue?vue&type=template&id=525460ea&scoped=true&"
import script from "./autoRouterparent.vue?vue&type=script&lang=js&"
export * from "./autoRouterparent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "525460ea",
  null
  
)

export default component.exports